import * as sessionManager from '$domain/model/session/session.manager'

export const isUserAuthenticated = () => {
  return sessionManager.isAuthenticated()
}



// WEBPACK FOOTER //
// ./src/services/session/isAuthenticated/isAuthenticated.service.ts